// Розбір поданих декларацій з ПДВ (J0200126) і Д1 (J0200526) з «Перегляду звітності»: рядки декларації,
// включені зупинені ПН (табл. 1.1), використаний кредит (2.1) і коригування кредиту (2.2), реквізити платника
import { orgFromXml } from "./xml.js";

const body = (xml) => String(xml).slice(String(xml).indexOf("<DECLARBODY>"));
const col = (b, t) => Object.fromEntries([...b.matchAll(new RegExp(`<${t} ROWNUM="(\\d+)"\\s*>([^<]*)<`, "g"))].map((m) => [m[1], m[2].trim()]));
const num = (v) => Number(String(v ?? "").replace(",", ".")) || 0;

export function parseDeclaration(xml) {
  const rows = {};
  for (const m of body(xml).matchAll(/<(R\d+G[AB0-9]+)>([^<]+)</g)) rows[m[1]] = num(m[2]);
  return { rows, org: orgFromXml(xml) };
}

export function parseD1(xml) {
  const b = body(xml);
  const t = (prefix, cols) => { const c = Object.fromEntries(cols.map((k) => [k, col(b, prefix + k)])); return Object.keys(c[cols[0]]).map((i) => Object.fromEntries(cols.map((k) => [k, c[k][i] ?? ""]))); };
  const t11 = t("T111RXXXX", ["G2", "G3D", "G4S", "G6", "G7"]).map((r) => ({ buyerIpn: r.G2, date: `${r.G3D.slice(4, 8)}-${r.G3D.slice(2, 4)}-${r.G3D.slice(0, 2)}`, nmr: r.G4S, base: num(r.G6), vat: num(r.G7) }));
  const t21 = t("T21RXXXX", ["G2", "G31", "G32", "G6", "G7", "G8", "G9", "G10"]).map((r) => ({ supplier: r.G2, month: num(r.G31), year: num(r.G32), base: num(r.G6), vat20: num(r.G7), vat7: num(r.G8), vat14: num(r.G9), vat: num(r.G10) }));
  const t22 = t("T22RXXXX", ["G2", "G311", "G312", "G331", "G332", "G4", "G5", "G8"]).map((r) => ({ supplier: r.G2, pnMonth: num(r.G311), pnYear: num(r.G312), rkMonth: num(r.G331), rkYear: num(r.G332), base: num(r.G4), vat20: num(r.G5), vat: num(r.G8) }));
  return { t11, t21, t22 };
}

// Д2: табл. 1 — від'ємне значення за походженням (графа 10 — що переходить до наступного періоду)
export function parseD2(xml) {
  const b = body(xml);
  const c = Object.fromEntries(["G2", "G3", "G4", "G51", "G52", "G6", "G10"].map((k) => [k, col(b, "T1RXXXX" + k)]));
  return Object.keys(c.G2).map((i) => ({ month: num(c.G2[i]), year: num(c.G3[i]), supplier: c.G4[i], pnMonth: num(c.G51[i]), pnYear: num(c.G52[i]), amount: num(c.G6[i]), carry: num(c.G10[i]) }));
}
